var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.3 27.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1799d5;\n      }\n\n      .cls-2 {\n        opacity: .8;\n      }\n\n      .cls-3 {\n        opacity: .6;\n      }\n\n      .cls-4 {\n        fill: #13294b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M45,24.9c5.5,0,6.8-4.7,6.8-9.4s-1.2-9.3-6.6-9.3-6.9,4.8-6.9,9.4,1.3,9.2,6.8,9.2M45.2,4.1c6.7,0,10.7,4.7,10.7,11.3s-4,11.7-11.1,11.7-10.7-4.3-10.7-11.3,3.4-11.7,11.1-11.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M56,26.4v-1.9h1.7c.3,0,.9-.2.9-1.2v-10.3c0-.6-.4-.8-.8-.8h-2.6l-.5-1.7,7.3-.6v1.9l-.3,1.6c1.3-2.3,3.2-3.6,5.7-3.6s5.1,1.5,5.1,4.2v9.6c0,.4.4.9.8.9h1.8v1.9h-8.3v-1.9h1.5c.5,0,.9-.4.9-.8v-8.9c0-1.7-1.4-2.5-2.9-2.5s-4.3,1.8-4.3,4v7c0,.9.3,1.2.9,1.2h1.7v1.9s-8.6,0-8.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M78.1,16.6h7.9c0-2.5-.9-4.8-3.8-4.8s-4.1,2.2-4.1,4.8M82.4,9.8c5.4,0,7.6,3.9,7.6,8.9h-11.9c0,4.5,2.2,5.9,4.9,5.9,4,0,4.8-3.6,4.8-3.6h2.1c0,2.3-2.7,5.9-7.3,5.9s-8.2-3.6-8.2-8.5,3.1-8.6,8.1-8.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103,17.3l-3-8-.3-1.6-.4,1.6-3,8s6.7,0,6.7,0ZM89.3,24.3c1.2,0,1.9,0,2.4-1.2l7-18.4h3.4l7.1,18.7c.3.8,1.3.9,2.1.9h.5v2.1h-9.3v-2.1h1.9c.6,0,.8-.6.8-1s0-.2-1.4-3.9h-8.4c-.8,2.5-1.3,3.7-1.3,4,0,.9.8.9,2.2.9h.6v2.1h-7.9v-2.1h.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.9,26.4h-1.7v-6.1h1.7c.4,2.7,2.4,4.4,5.4,4.4s3.6-.6,3.6-2.5-1-1.7-2.1-2l-4.9-1.2c-2.3-.6-3.9-1.9-3.9-4.4s3.2-4.9,6.2-4.9,3.3.4,4.7,1.5l.6-1.5h1.6v5.8h-1.7c-.6-2.7-2.3-3.7-5-3.7s-3.1.5-3.1,2.2.8,1.7,1.7,1.9l5.5,1.3c2.2.5,3.6,2.1,3.6,4.3,0,3.6-3.2,5.3-6.4,5.3s-3.8-.6-5.4-1.8c0,0-.4,1.4-.4,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.2,9.8c2.5,0,5.8,1.3,5.8,4.3s-1,2.4-2.4,2.4-2.1-.8-2.1-2,.4-1.5,1.2-2c-.5-.6-1.8-.6-2.6-.6-3.5,0-4.4,3.3-4.4,6.3s1,6.1,4.6,6.1,4.2-1.5,4.2-3.8h2.2c0,3.9-2.8,6.3-7,6.3s-7.8-3.6-7.8-8.3,3.3-8.7,8.5-8.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M144.7,16.6h7.9c0-2.5-.9-4.8-3.8-4.8s-4.1,2.2-4.1,4.8M149,9.8c5.4,0,7.6,3.9,7.6,8.9h-12c0,4.5,2.2,5.9,4.9,5.9,4,0,4.8-3.6,4.8-3.6h2.1c0,2.3-2.6,5.9-7.3,5.9s-8.2-3.6-8.2-8.5,3.1-8.6,8.1-8.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156.6,26.4v-1.9h1.7c.3,0,.9-.2.9-1.2v-10.3c0-.6-.4-.8-.8-.8h-2.1v-1.8l6.2-.5v1.9l-.3,1.6c1.3-2.3,3.2-3.6,5.7-3.6s5.1,1.5,5.1,4.2v9.6c0,.4.4.9.8.9h1.8v1.9h-8.3v-1.9h1.5c.5,0,.9-.4.9-.8v-8.9c0-1.7-1.4-2.5-2.9-2.5s-4.3,1.8-4.3,4v7c0,.9.3,1.2.9,1.2h1.7v1.9h-8.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.9,10.4v1.8h-3.6v11.1c0,1.1.4,1.4,1.6,1.4s1.4,0,2.4-.3v1.9c-1.6.4-2.5.6-4,.6s-2.5-.4-3-1.1c-.3-.5-.4-1.1-.4-2.7v-10.9h-2.7v-1.8c3.2,0,3.8-2.1,3.8-6.3h2.3v6.3h3.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 3.8 0 22.6 7.8 9.3 0 3.8"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.4 3.8 18.6 9.3 26.4 22.6 26.4 3.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.2 0 7.8 9.3 13.2 13.2 18.6 9.3 13.2 0"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 22.6 26.4 22.6 13.2 13.2 0 22.6"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.6 9.3 18.6 9.3 13.2 13.2 26.4 22.6 18.6 9.3"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.8 9.3 7.8 9.3 0 22.6 13.2 13.2 7.8 9.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 24.5,
    width: 26.4,
    height: 1.9
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3ba7d92d28cc7699093fad00e6fab68d.svg";
export { ForwardRef as ReactComponent };